module.exports = __webpack_public_path__ + "img/mail.9ea7226d.png";